import React from 'react';
import { Pagination } from 'react-bootstrap';

const PaginationControl = ({ totalPages, currentPage, setCurrentPage }) => {
  if (totalPages <= 1) return null;

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      if (currentPage > 2) {
        pages.push(1);
        if (currentPage > 3) pages.push('start-ellipsis');
      }

      // Show current page and neighbors
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      // Always show last page
      if (currentPage < totalPages - 1) {
        if (currentPage < totalPages - 2) pages.push('end-ellipsis');
        pages.push(totalPages);
      }
    }

    return pages.map((page, index) => {
      if (page === 'start-ellipsis' || page === 'end-ellipsis') {
        return <Pagination.Ellipsis key={page + index} disabled className="ms-2" />;
      }

      return (
        <Pagination.Item
          key={page}
          active={page === currentPage}
          className="ms-2"
          onClick={() => setCurrentPage(page)}
        >
          {page}
        </Pagination.Item>
      );
    });
  };

  return (
    <div className="d-flex justify-content-center mt-4">
      <Pagination>
        <Pagination.Item onClick={handlePrev} disabled={currentPage === 1}>
          Prev
        </Pagination.Item>

        {renderPageNumbers()}

        <Pagination.Item
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className="ms-2"
        >
          Next
        </Pagination.Item>
      </Pagination>
    </div>
  );
};

export default PaginationControl;
